export default __webpack_public_path__ + "static/media/skin.19bb70e8.svg";